
(() => {
  'use strict';
  const KEY='bm-recently-viewed-v1';
  const productPath=value=>{
    try{const u=new URL(value,location.origin);return u.origin===location.origin && /\/products\/[^/]+\/?$/.test(u.pathname)?u.pathname:'';}
    catch(_){return '';}
  };
  const imageUrl=value=>{
    try{const u=new URL(value,location.origin);return ['http:','https:'].includes(u.protocol)?u.href:'';}
    catch(_){return '';}
  };
  const clean=item=>{
    if(!item||typeof item.title!=='string')return null;
    const url=productPath(item.url);
    if(!url)return null;
    return {url,title:item.title.slice(0,240),image:imageUrl(item.image),price:String(item.price||'').slice(0,80),available:item.available!==false};
  };
  const read=()=>{
    try{const raw=JSON.parse(localStorage.getItem(KEY)||'[]');return Array.isArray(raw)?raw.map(clean).filter(Boolean).slice(0,20):[];}
    catch(_){return [];}
  };
  const write=items=>{try{localStorage.setItem(KEY,JSON.stringify(items));}catch(_){}};
  const node=(tag,cls,text)=>{
    const e=document.createElement(tag);if(cls)e.className=cls;if(text!==undefined)e.textContent=text;return e;
  };
  const start=()=>{
    let history=read();
    const current=document.querySelector('[data-bm-current-product]');
    let currentUrl='';
    if(current){
      try{
        const item=clean(JSON.parse(current.textContent));
        if(item){currentUrl=item.url;history=[item,...history.filter(x=>x.url!==item.url)].slice(0,20);write(history);}
      }catch(_){}
    }
    document.querySelectorAll('[data-bm-recently-viewed]').forEach(section=>{
      const container=section.querySelector('[data-bm-recently-list]');
      if(!container)return;
      container.replaceChildren();
      const exclude=productPath(section.dataset.currentProduct)||currentUrl;
      const limit=Math.min(10,Math.max(2,Number(section.dataset.limit)||6));
      const items=history.filter(x=>x.url!==exclude&&x.available).slice(0,limit);
      if(!items.length){section.hidden=true;return;}
      items.forEach(item=>{
        const link=node('a','bm-recently-viewed__item');link.href=item.url;
        if(item.image){const img=node('img','bm-recently-viewed__image');img.src=item.image;img.alt='';img.loading='lazy';link.appendChild(img);}
        link.appendChild(node('p','bm-recently-viewed__name',item.title));
        if(item.price)link.appendChild(node('p','bm-recently-viewed__price',item.price));
        container.appendChild(link);
      });
      section.hidden=false;
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
